import { useEffect, useState } from 'preact/hooks'

function GeolocatorPopup() {
  const [showPopup, setShowPopup] = useState(false)
  const [popupContent, setPopupContent] = useState({})

  const showGeoPopup = (e) => {
    setShowPopup(true)
    document.body.style.overflow = 'hidden'
    document.cookie = 'geo_popup_shown=1; path=/; max-age=' + (30 * 24 * 60 * 60) // 30 days
  }

  // Close popup on outside click
  const closePopupOnOutsideClick = (e) => {
    const popupElement = document.getElementById('popup')
    if (popupElement && !popupElement.contains(e.target)) {
      setShowPopup(false)
    }
  }

  useEffect(() => {
    const Cookie = {
      set: (name, value, days) => {
        let expires = ''
        if (days) {
          const date = new Date()
          date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
          expires = '; expires=' + date.toUTCString()
        }
        document.cookie = `${name}=${value || ''}${expires}; path=/`
      },
      get: (name) => {
        const nameEQ = name + '='
        const ca = document.cookie.split(';')
        for (let i = 0; i < ca.length; i++) {
          let c = ca[i]
          while (c.charAt(0) === ' ') c = c.substring(1)
          if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length)
        }
        return null
      }
    }

    // Get the data-content attribute from the <geolocator-popup> element
    const geolocatorPopupElement = document.querySelector('geolocator-popup')
    const dataContent = geolocatorPopupElement?.getAttribute('data-content')
    let parsedContent = {}

    if (dataContent) {
      try {
        // Parse the JSON data from the data-content attribute
        parsedContent = JSON.parse(dataContent)
      } catch (error) {
        console.error('Error parsing JSON content from data-content:', error)
      }
    } else {
      return
    }

    // Check if the popup should be displayed
    if ((parsedContent.display_enabled && Shopify.designMode) || (!Cookie.get('geo_popup_shown') && !Shopify.designMode)) {
      document.addEventListener('click', closePopupOnOutsideClick)

      fetch(
        window.Shopify.routes.root +
        'browsing_context_suggestions.json' +
        '?country[enabled]=true' +
        `&country[exclude]=${window.Shopify.country}` +
        '&language[enabled]=true' +
        `&language[exclude]=${window.Shopify.language}`
      )
        .then(r => r.json())
        .then(data => {
          if (!data.detected_values || !data.detected_values.country) return

          const userCountry = data.detected_values.country.handle?.toUpperCase()
          const currentDomain = document.body.dataset.host

          if ((currentDomain.includes('mocka-au.myshopify.com') && userCountry === 'NZ') ||
            (currentDomain.includes('mocka-nz.myshopify.com') && userCountry === 'AU') ||
            (parsedContent.display_enabled && Shopify.designMode)) {
            setPopupContent({
              image_mobile: parsedContent.popup_image_mobile,
              image_desktop: parsedContent.popup_image_desktop,
              title: parsedContent.popup_title,
              description: parsedContent.popup_description,
              redirectUrl: parsedContent.popup_redirection_cta_link,
              redirectLabel: parsedContent.popup_redirection_cta_label,
              stayLabel: parsedContent.popup_stay_cta_label
            })
            showGeoPopup()
          }
        })
        .catch(console.error)
    }
  }, [])

  if (!showPopup) return null

  return (
    <div class='z-[90001] fixed inset-0 flex items-center justify-center w-full h-full bg-[rgba(0,0,0,0.50)]'
      onClick={(e) => {
        e.preventDefault()
      }}>
      <div id='popup' class='bg-white rounded-[4px] flex flex-col lg:flex-row w-full max-w-[344px] lg:max-w-[552px] overflow-hidden'>
        <div class='w-full lg:w-[214px] min-w-[214px] relative'>
          <div class='relative w-full pb-[64%] lg:pb-[146%]'>
            <img class='absolute w-full h-full object-cover block lg:hidden' src={popupContent.image_mobile} alt={popupContent.title} />
            <img class='absolute w-full h-full object-cover hidden lg:block' src={popupContent.image_desktop} alt={popupContent.title} />
          </div>
        </div>
        <div class='pt-[40px] px-[24px] pb-[32px] lg:px-[32px] lg:py-[40px] lg:pt-[56px] text-center text-[14px] text-[#181818] leading-[24px]'>
          <p class='text-[16px] font-medium mb-2'>{popupContent.title}</p>
          <p class='mb-6'>{popupContent.description}</p>
          <div class='flex flex-col gap-4'>
            <button class='rounded-[99px] bg-[#363636] hover:bg-black text-white font-medium py-3 px-4 transition-colors'
              onClick={() => {
                window.location.href = popupContent.redirectUrl
              }}
              title={popupContent.redirectLabel}
            >
              {popupContent.redirectLabel}
            </button>
            <a
              href="#"
              title={popupContent.stayLabel}
              class='text-[#666] hover:text-black transition-colors underline underline-offset-[7px]'
              onClick={(e) => {
                e.preventDefault()
                setShowPopup(false)
                document.body.style.overflow = 'auto'
              }}
            >
              {popupContent.stayLabel}
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default GeolocatorPopup
